export default __webpack_public_path__ + "static/automation-8dd6c43eba199b6767c6477d61797420.png";